import React from 'react';
import classNames from 'classnames';

import styles from '../styles/Score.css';
import uiStyles from  '../styles/common.css';

export default (props) => {
  return (
    <div className={styles.scoreScreen}>
      <div className={styles.scoreSummary}>
        <h1 className={styles.points}>Score: {props.api.score}</h1>
        <h1 className={styles.right}>Right: {props.api.correctAnswers}</h1>
        <h1 className={styles.wrong}>Wrong: {props.api.wrongAnswers}</h1>
      </div>
      <a className={styles.nextBtn} onClick={()=>props.onNextBtn()}>Play Again</a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Score.js